export default "/images/e0e6cad1efdb8e5ba53bb26002f0613c.png";